import { Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import colores from '../../shared/constants/styles';
import { ICuentaBancaria } from '../cuentaBancaria/interface/iCuentaBancaria';

interface CuentaBancariaDialogProps {
    open: boolean;
    onClose: () => void;
    onGuardar: (request: ICuentaBancaria) => void;
    cuentaBancaria?: ICuentaBancaria;
}

const CuentaBancariaDialog = (props: CuentaBancariaDialogProps) => {
    const [nombre, setNombre] = useState<string>("");
    const [sucursal, setSucursal] = useState<string>("");
    const [nroCuenta, setNroCuenta] = useState<string>("");
    const [cbu, setCbu] = useState<string>("");
    const [alias, setAlias] = useState<string| undefined>();
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    let contactoRequest: ICuentaBancaria = {
        id: 0,
        nombre,
        sucursal,
        nroCuenta,
        cbu,
        alias
    };

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (props.cuentaBancaria) {
            setNombre(props.cuentaBancaria.nombre);
            setSucursal(props.cuentaBancaria.sucursal);
            setNroCuenta(props.cuentaBancaria.nroCuenta);
            setCbu(props.cuentaBancaria.cbu.toString());
            setAlias(props.cuentaBancaria.alias);
        } else {
            setNombre("");
            setSucursal("");
            setNroCuenta("");
            setCbu("");
            setAlias("");
        }
    }, [props.cuentaBancaria, props.open]);

    const handleSubmit = () => {
        let valid = true;
        const newErrors: any = {};

        if (!nombre.trim()) {
            newErrors.nombre = "El nombre es obligatorio.";
            valid = false;
        }
        if (!sucursal.trim()) {
            newErrors.sucursal = "La sucursal es obligatorio.";
            valid = false;
        } 
        if (!nroCuenta.trim()) {
            newErrors.nroCuenta = "El nro. de cuenta es obligatorio.";
            valid = false;
        }
        if (!cbu.trim()) {
            newErrors.cbu = "El cbu es obligatorio.";
            valid = false;
        }
        
        setErrors(newErrors);
        if (!valid) return;   
        
        contactoRequest = {
            ...props.cuentaBancaria,
            nombre,
            sucursal, 
            nroCuenta,
            cbu,
            alias
        };     
        props.onGuardar(contactoRequest);
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
            <DialogTitle>{props.cuentaBancaria ? "Editar cuenta bancaria" : "Crear cuenta bancaria"}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nro. Cuenta"
                    fullWidth
                    disabled={props.cuentaBancaria?.id ? props.cuentaBancaria?.id > 0: false}
                    value={nroCuenta ?? ""}
                    onChange={(e) => setNroCuenta(e.target.value)}              
                    margin="normal"
                    error={Boolean(errors.nroCuenta)}
                    helperText={errors.nroCuenta}
                />   
                <TextField
                    label="Nombre"
                    fullWidth
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.nombre)}
                    helperText={errors.nombre}
                /> 
                <TextField
                    label="Sucursal"
                    fullWidth
                    value={sucursal}
                    onChange={(e) => setSucursal(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.sucursal)}
                    helperText={errors.sucursal}
                />  
                <TextField
                    label="CBU"
                    fullWidth
                    value={cbu}
                    onChange={(e) => setCbu(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.cbu)}
                    helperText={errors.cbu}
                /> 
                <TextField
                    label="Alias"
                    fullWidth
                    value={alias}
                    onChange={(e) => setAlias(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.alias)}
                    helperText={errors.alias}
                />  
            </DialogContent>
            <DialogActions>
                <button 
                    type="submit" 
                    style={{background: colores.grisOscuro, color: 'white'}} className="btn" onClick={props.onClose}>
                    Cancelar
                </button>
                <button 
                    type="submit" 
                    style={{background: colores.rojo, color: 'white'}} className="btn" onClick={handleSubmit}>
                    {props.cuentaBancaria ? "Actualizar" : "Crear"}
                </button>
            </DialogActions>
        </Dialog>
    );
};
export default connect()(CuentaBancariaDialog);
